<template>
  <button
    :class="{ 'is-loading': state.isLoading }"
    class="is-clickable editing"
    @click="state.isModalOpen = true"
  >
    <OpenaiIcon />
  </button>
</template>

<script>
import OpenaiIcon from "icons/cached/openai.svg";
import { state } from "./describeAnimalContext.js";

export default {
  components: {
    OpenaiIcon,
  },
  setup() {
    return {
      state,
    };
  },
};
</script>
